import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["prefixCls", "className", "steps", "strokeColor", "percent", "size", "showInfo", "type"];
import { IconCancel20pxRegular, IconCheckMark16pxRegular, IconClose16pxRegular, IconSuccess20pxRegular } from "@pionex-web-kit/icons";
import classNames from "classnames";
import * as React from "react";
import { ConfigContext } from "../ConfigProvider/context";
import omit from "../hack/rc-util/omit";
import { tuple } from "../hack/_util/type";
import warning from "../hack/_util/warning";
import Circle from "./Circle";
import Line from "./Line";
import Steps from "./Steps";
import { getSuccessPercent, validProgress } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
var ProgressTypes = tuple("line", "circle", "dashboard");
var ProgressStatuses = tuple("normal", "exception", "active", "success");
export var Progress = function Progress(props) {
  var _classNames;
  var customizePrefixCls = props.prefixCls,
    className = props.className,
    steps = props.steps,
    strokeColor = props.strokeColor,
    _props$percent = props.percent,
    percent = _props$percent === void 0 ? 0 : _props$percent,
    _props$size = props.size,
    size = _props$size === void 0 ? "default" : _props$size,
    _props$showInfo = props.showInfo,
    showInfo = _props$showInfo === void 0 ? true : _props$showInfo,
    _props$type = props.type,
    type = _props$type === void 0 ? "line" : _props$type,
    restProps = _objectWithoutProperties(props, _excluded);
  function getPercentNumber() {
    var successPercent = getSuccessPercent(props);
    return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
  }
  function getProgressStatus() {
    var status = props.status;
    if (ProgressStatuses.indexOf(status) < 0 && getPercentNumber() >= 100) {
      return "success";
    }
    return status || "normal";
  }
  function renderProcessInfo(prefixCls, progressStatus) {
    var format = props.format;
    var successPercent = getSuccessPercent(props);
    if (!showInfo) {
      return null;
    }
    var text;
    var textFormatter = format || function (percentNumber) {
      return "".concat(percentNumber, "%");
    };
    var isLineType = type === "line";
    if (format || progressStatus !== "exception" && progressStatus !== "success") {
      text = textFormatter(validProgress(percent), validProgress(successPercent));
    } else if (progressStatus === "exception") {
      text = isLineType ? /*#__PURE__*/_jsx(IconCancel20pxRegular, {
        size: 16
      }) : /*#__PURE__*/_jsx(IconClose16pxRegular, {
        size: 28
      });
    } else if (progressStatus === "success") {
      text = isLineType ? /*#__PURE__*/_jsx(IconSuccess20pxRegular, {
        size: 16
      }) : /*#__PURE__*/_jsx(IconCheckMark16pxRegular, {
        size: 28
      });
    }
    return /*#__PURE__*/_jsx("span", {
      className: "".concat(prefixCls, "-text"),
      title: typeof text === "string" ? text : undefined,
      children: text
    });
  }
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction;
  var prefixCls = getPrefixCls("progress", customizePrefixCls);
  var progressStatus = getProgressStatus();
  var progressInfo = renderProcessInfo(prefixCls, progressStatus);
  warning(!("successPercent" in props), "Progress", "`successPercent` is deprecated. Please use `success.percent` instead.");
  var strokeColorNotArray = Array.isArray(strokeColor) ? strokeColor[0] : strokeColor;
  var strokeColorNotGradient = typeof strokeColor === "string" || Array.isArray(strokeColor) ? strokeColor : undefined;
  var progress;
  // Render progress shape
  if (type === "line") {
    progress = steps ? /*#__PURE__*/_jsx(Steps, _objectSpread(_objectSpread({}, props), {}, {
      strokeColor: strokeColorNotGradient,
      prefixCls: prefixCls,
      steps: steps,
      children: progressInfo
    })) : /*#__PURE__*/_jsx(Line, _objectSpread(_objectSpread({}, props), {}, {
      strokeColor: strokeColorNotArray,
      prefixCls: prefixCls,
      direction: direction,
      children: progressInfo
    }));
  } else if (type === "circle" || type === "dashboard") {
    progress = /*#__PURE__*/_jsx(Circle, _objectSpread(_objectSpread({}, props), {}, {
      strokeColor: strokeColorNotArray,
      prefixCls: prefixCls,
      progressStatus: progressStatus,
      children: progressInfo
    }));
  }
  var classString = classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type === "dashboard" && "circle" || steps && "steps" || type), true), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(progressStatus), true), _defineProperty(_classNames, "".concat(prefixCls, "-show-info"), showInfo), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _defineProperty(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, omit(restProps, ["status", "format", "trailColor", "strokeWidth", "width", "gapDegree", "gapPosition", "strokeLinecap", "success"])), {}, {
    className: classString,
    children: progress
  }));
};